<template>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="description" content="">
    <meta name="author" content="Sylva Foundation">
    <meta name="generator" content="Hugo 0.84.0">
    <title>Forestry and Climate Change Partnership</title>


    
    <!-- Custom styles for this template -->
  </head>
  <body>


  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->

<div class="container marketing">
  <div class="row">
      <h3 class="greeni mb-4">
      Resources
      </h3>
    <div class="col-lg mb-3">
      <p>
      Three key documents for the Forestry and Climate Change Partnership are our Terms of Reference, Action Plan, and the Accord.
      </p> 
    </div>
    <div class="col-lg mb-3">
      <p> 
      We also signpost to key resources hosted by our partner organisations and others.
      </p>
    </div>
  </div>
  <resource-list></resource-list>
</div>

      
  </body>
</html>
</template>

<script>
import ResourceList from './ResourceList.vue'
export default {
  components: {ResourceList},
  name: 'Resources',
  props: {
  } 
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }

      @media (min-width: 768px) {
        .bd-placeholder-img-lg {
          font-size: 3.5rem;
        }
      }
</style>
